/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable camelcase */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
import React, {
    useState, useCallback, useEffect, useContext, useRef,
} from 'react';
import { motion } from 'framer-motion';
import HeaderContext from '../../Components/Context/HeaderContext';
import { distributorService } from '../../service/distributor.service';
import TransactionFiltermodal from './Filtermodal';
import TransactionsListSkeleton from './transactionlistSkeleton';
import { PriceHandler } from '../../redux/helper/CamelCase';
import { GenerateDateandTime } from '../../redux/helper/DateConverter';
import Pagination from '../../Components/Pagination';
import UpdateTransactionModal from './UpdateTransactionModal';
import EmptyScreen from '../../Components/GlobalEmplyPage';

function ManageTransactions() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const [transactionsList, setTransactionsList] = useState([]);
    const [sortType, setsortType] = useState('transaction_date+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [isEditId, setisEditId] = useState('');
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [Loading, setLoading] = useState(true);
    const [emptyData, setEmptyData] = useState(false);
    const [filterModal, setFilterModal] = useState(false);
    const [filterValue, setfilterValue] = useState('');
    const [updateTransactionModal, setUpdateTransactionModal] = useState(false);
    const [invoicesearchValue, setInvoicesearchValue] = useState('');
    const [selectedTransaction, setSelectedTransaction] = useState([]);
    const [selectedItem, setSelectedItem] = useState({});
    const [threeDotsLoader, setThreeDotsLoader] = useState(false);
    const [updateTransactionInformation, setUpdateTransactionInformation] = useState({
        invoice: '',
        amount: '',
        amount_due: '',
    });
    const [Filter, setFilter] = useState({
        transaction_status: [],
    });

    const transaction_status = {
        0: 'Unassigned',
        1: 'Partial',
        2: 'Assigned',
    };

    const { access_privilages } = JSON.parse(localStorage.getItem('user')).profile;

    const validate = () => {
        let isvalid = true;
        Object.keys(updateTransactionInformation).forEach((value) => {
            switch (value) {
            case 'invoice':
            case 'amount':
                if (updateTransactionInformation[value] === '') {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [value]: `${value} is required`,
                    }));
                    isvalid = false;
                }
                break;
            default: break;
            }
        });
        return isvalid;
    };

    const handleFilter = (filterUrl) => {
        if (filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setLoading(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setLoading(true);
    }, [currentPage, sortType]);

    const handleFetchTransactionsList = useCallback((() => {
        distributorService.TransactionsList(currentPage, sortType, debouncedSearch, filterValue).then((response) => {
            if (response.error === false && response.data.data.success_status === true) {
                if (response.data.data.Items.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setTransactionsList(response.data.data.Items);
                setalldata(response);
                setCurrentPage(response.data.data.current_page);
                setTotalPage(response.data.data.number_of_pages);
            } else {
                setLoading(false);
                setalldata([]);
            }
        });
    }), [currentPage, debouncedSearch, sortType, filterValue]);

    const handleUpdateTransaction = async (item) => {
        const particularData = await distributorService.ParticularCustomerInvoicesList(item.account_number, invoicesearchValue);
        setSelectedTransaction(particularData.data.data.Items);
        setUpdateTransactionModal(true);
    };

    const handleUpdate = async () => {
        if (validate()) {
            setThreeDotsLoader(true);
            const payload = {
                invoice_id: updateTransactionInformation.invoice,
                amount: Number(updateTransactionInformation.amount),
            };
            const updatedTransaction = await distributorService.UpdateParticularTransaction(selectedItem.payment_id, payload);
            setUpdateTransactionModal(false);
            if (updatedTransaction.error) {
                SetErrorMessage(updatedTransaction?.message);
                setcolorValue('red');
                setTimeout(() => {
                    SetErrorMessage('');
                    setcolorValue('');
                }, 2000);
                setThreeDotsLoader(false);
            } else {
                SetSuccessMessage(updatedTransaction?.data.message);
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
                setThreeDotsLoader(false);
            }
            setUpdateTransactionInformation((prevState) => ({
                ...prevState,
                invoice: '',
                amount: '',
                amount_due: '',
            }));
            setThreeDotsLoader(false);
            handleFetchTransactionsList();
        }
    };

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    useEffect(() => {
        handleFetchTransactionsList();
    }, [handleFetchTransactionsList]);

    return (
        <div className="py-6 main-screen">
            <div className="flex justify-between items-center pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">Transactions</h5>
                <div className="flex items-center">
                    <button
                        type="button"
                        className="bg-[#F5F5FA] font-bold text-xs h-9 text-[#555259] border-2 border-[#E9EDF4] py-1 px-4 rounded-[9px] mr-2.5"
                        style={{
                            border: '2px solid #E9EDF4',
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#filtermodal"
                        onClick={() => setFilterModal(true)}
                        data-testid="filter-btn"
                    >
                        Filter
                    </button>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input
                            type="text"
                            name="search"
                            id="search"
                            className="w-[230px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]"
                            placeholder="Search"
                            value={searchValue}
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                            }}
                            autoComplete="off"
                        />
                        <img src="images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    {/* <div className="mr-2 dropdown relative">
                        <button type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[79px] border border-[#555259] rounded-lg">
                            Export
                        </button>
                        <ul className="dropdown-menu sm:min-w-[140px] min-w-[120px] absolute hidden bg-[#FFFFFF] rounded-lg shadow-s2 z-[9999] sm:p-3.5 p-1.5" aria-labelledby="exportDropdown">
                            <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5 export border-b border-[#D8D8D8]">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#">CSV</a>
                            </li>
                            <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5 border-b border-[#D8D8D8]">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#">PDF</a>
                            </li>
                            <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#">Excel</a>
                            </li>
                        </ul>
                    </div> */}
                </div>
            </div>
            {Loading ? <TransactionsListSkeleton /> : (
                <div>
                    {transactionsList.length > 0 && (
                        <div
                            className="overflow-auto top-0 left-0 dropdown-menu pb-7 relative z-10"
                            style={{ height: 'calc(100vh - 298px)' }}
                        >
                            <table className="w-full table-auto relative">
                                <thead className="top-0 left-0 sticky z-[2]">
                                    <tr className="bg-[#555259] h-10">
                                        <th className="py-[5px] px-6 rounded-bl-lg rounded-tl-lg min-w-[171px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                            <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                Transaction No.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                Transaction Date
                                                <a href="#" className="pl-[5px]">
                                                    <motion.img
                                                        animate={{ rotate: sortType === 'transaction_date+asc' ? 180 : 0 }}
                                                        className={`${sortType === 'transaction_date+desc' ? 'image-rotate' : ''}`}
                                                        src="/images/sort.svg"
                                                        alt="icon"
                                                        onClick={() => {
                                                            if (sortType === 'transaction_date+asc') {
                                                                setsortType('transaction_date+desc');
                                                            } else if (sortType === 'transaction_date+desc') {
                                                                setsortType('transaction_date+asc');
                                                            } else {
                                                                setsortType('transaction_date+asc');
                                                            }
                                                            setCurrentPage(1);
                                                            // setisLoaded(true);
                                                        }}
                                                    />
                                                </a>
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[160px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                Account No.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[200px] text-center">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                Account Holder Name
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[160px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-end">
                                                Amount
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[188px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                Customer Name
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[170px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                Customer Code
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center text-center justify-center">
                                                Invoice Nos.
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[180px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                Transaction Status
                                            </span>
                                        </th>
                                        <th scope="col" className="py-[5px] px-7 min-w-[370px]">
                                            <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                Comments
                                            </span>
                                        </th>
                                        <th scope="col" className="rounded-tr-lg rounded-br-lg sticky top-0 right-0 bg-[#555259] py-[5px] px-7 min-w-[60px]" />
                                    </tr>
                                </thead>
                                <tbody>
                                    {transactionsList.length > 0 && transactionsList.map((item, i) => (
                                        <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                            <td
                                                className="text-sm font-normal text-[#090406] py-[5px] px-7 sticky top-0 left-0 text-center z-[1]"
                                                // style=" background: rgba(255, 255, 255, 0.45); backdrop-filter: blur(5.5px); position: -webkit-sticky; position: sticky; left: 0; z-index: 9;"
                                                style={{
                                                    background: 'rgba(255, 255, 255, 0.45)',
                                                    backdropFilter: 'blur(5.5px)',
                                                }}
                                            >
                                                {item?.payment_id}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-[5px] px-7">
                                                {GenerateDateandTime(item?.transaction_date)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-[5px] px-7">
                                                {item?.info.payload?.bank_transfer.entity.payer_bank_account.account_number}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-[5px] px-7">
                                                {item?.info.payload?.bank_transfer.entity.payer_bank_account.name}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-end">
                                                {PriceHandler(item?.amount)}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-[5px] px-7">
                                                {item?.info.payload?.virtual_account?.entity.notes.distributor_name || item?.info.payload?.virtual_account?.entity.description.split('Virtual Account created for ')[1] }
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-[5px] px-7">
                                                {item?.account_number}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center break-words max-w-[235px]">
                                                {item?.invoices.length > 0 ? item?.invoices.join(',')
                                                    : '-'}
                                            </td>
                                            <td className="text-sm font-normal text-[#090406] py-[5px] px-7">
                                                {transaction_status[item?.status]}
                                            </td>
                                            {item?.comments === null
                                                ? (
                                                    <td className="text-sm font-normal text-[#090406] py-[5px] px-7">-</td>
                                                )
                                                : (
                                                    <td className="text-sm font-normal text-[#090406] py-[5px] px-7">
                                                        {item?.info.payload?.payment.entity.description}
                                                    </td>
                                                ) }
                                            {access_privilages.includes('transactions:update')
                                            && (
                                                <td
                                                    onClick={() => {
                                                        if (isEditId === i) {
                                                            setisEditId('');
                                                        } else {
                                                            setisEditId(i);
                                                        }
                                                    }}
                                                    className="py-[5px] px-7 sticky right-0 bg-[#ffffffe6] z-[1]"
                                                    style={{
                                                        background: 'rgba(255, 255, 255, 0.45)',
                                                        backdropFilter: 'blur(5.5px)',
                                                    }}
                                                >
                                                    <div className="dropdown relative">
                                                        <button className="dropdown-toggle" type="button" id="dropdownMenuButton111" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <img src="/images/more-vertical.svg" alt="icon" className="cursor-pointer" />
                                                        </button>
                                                        {isEditId !== '' && (
                                                            <ul className={`dropdown-menu min-w-max ${isEditId === i ? 'show' : 'hidden'} absolute bg-[#FFFFFF] rounded-[10px] shadow-s2 top-0 right-10`} aria-labelledby="dropdownMenuButton111">
                                                                <li
                                                                    className="px-5 pb-3 pt-3"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#updateTransaction"
                                                                    onClick={() => { setSelectedItem(item); handleUpdateTransaction(item); }}
                                                                >
                                                                    <a className="dropdown-item text-xs5 font-normal text-[#555259] w-full inline-block" href="#">Update Transaction Information</a>
                                                                </li>
                                                            </ul>
                                                        )}
                                                    </div>
                                                </td>
                                            )}
                                        </tr>

                                    ))}

                                </tbody>
                            </table>
                        </div>

                    )}
                    {!Loading && transactionsList && transactionsList.length > 0 && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            totalPage={totalPage}
                            List={alldata}
                            currentPage={currentPage}
                        />
                    )}
                    {filterModal && (
                        <TransactionFiltermodal
                            filterModal={filterModal}
                            setFilterModal={setFilterModal}
                            Filter={Filter}
                            setFilter={setFilter}
                            filterValue={filterValue}
                            setfilterValue={setfilterValue}
                            handleFilter={handleFilter}
                            handleFetchTransactionsList={handleFetchTransactionsList}
                            SetSuccessMessage={SetSuccessMessage}
                        />
                    )}
                    {updateTransactionModal && (
                        <UpdateTransactionModal
                            updateTransactionModal={updateTransactionModal}
                            setUpdateTransactionModal={setUpdateTransactionModal}
                            selectedTransaction={selectedTransaction}
                            setSelectedTransaction={setSelectedTransaction}
                            updateTransactionInformation={updateTransactionInformation}
                            setUpdateTransactionInformation={setUpdateTransactionInformation}
                            invoicesearchValue={invoicesearchValue}
                            setInvoicesearchValue={setInvoicesearchValue}
                            handleUpdate={handleUpdate}
                            selectedItem={selectedItem}
                            threeDotsLoader={threeDotsLoader}
                            setThreeDotsLoader={setThreeDotsLoader}
                        />
                    )}
                    {emptyData && (
                        <EmptyScreen
                            search="yes"
                            all={debouncedSearch !== '' ? 'under searched term' : 'found'}
                            text=" no Transactions"
                            buttonRequired={false}
                        />
                    )}
                </div>
            )}

        </div>
    );
}

export default ManageTransactions;
